import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { dayLabel } from "@/lib/dates";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SlotDialog = ({ ctx, members, vehicles, myVehicles, onClose, onSaved }) => {
  const open = ctx.template.requirements.filter((r) => ctx.slots.filter((s) => s.position === r.key).length < r.count);
  const [position, setPosition] = useState(open[0]?.key || "");
  const [vehicle, setVehicle] = useState("");
  const [member, setMember] = useState("");
  const usable = vehicles.filter((v) => v.status !== "off_road" && (ctx.assign || !myVehicles?.length || myVehicles.includes(v.id)));
  const save = async () => {
    try {
      const body = { date: ctx.date, template_id: ctx.template.id, area_id: ctx.area.id, position, vehicle_id: vehicle || null };
      const { data } = ctx.assign ? await api.post("/rota/assign", { ...body, user_id: member }) : await api.post("/rota/signup", body);
      toast.success(`${data.user_name} booked on ${ctx.template.name}`);
      onSaved();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="slot-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{ctx.assign ? "Assign member" : "Sign up"}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{ctx.area.name} · {dayLabel(ctx.date)} · {ctx.template.name} {ctx.template.start}–{ctx.template.end}</p>
        {ctx.assign && (
          <div className="space-y-1.5"><Label>Member</Label>
            <Select value={member || undefined} onValueChange={setMember}><SelectTrigger data-testid="slot-member-select"><SelectValue placeholder="Select member" /></SelectTrigger>
              <SelectContent>{members.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}</SelectContent></Select>
          </div>
        )}
        <div className="space-y-1.5"><Label>Role on shift</Label>
          <Select value={position || undefined} onValueChange={setPosition}><SelectTrigger data-testid="slot-position-select"><SelectValue placeholder="No open places" /></SelectTrigger>
            <SelectContent>{open.map((r) => <SelectItem key={r.key} value={r.key}>{r.label}</SelectItem>)}</SelectContent></Select>
        </div>
        <div className="space-y-1.5"><Label>Book a vehicle (optional)</Label>
          <Select value={vehicle || "none"} onValueChange={(v) => setVehicle(v === "none" ? "" : v)}><SelectTrigger data-testid="slot-vehicle-select"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="none">No vehicle</SelectItem>{usable.map((v) => <SelectItem key={v.id} value={v.id}>{v.name} ({v.type === "car" ? "car" : "bike"})</SelectItem>)}</SelectContent></Select>
        </div>
        <button disabled={!position || (ctx.assign && !member)} onClick={save} data-testid="slot-save-btn" className="w-full rounded-full bg-primary py-3 text-sm font-bold text-primary-foreground disabled:opacity-40">Confirm</button>
      </DialogContent>
    </Dialog>
  );
};
